export default __webpack_public_path__ + "static/media/test-report.9aca66cd.svg";